<script setup>
defineProps({
  showBack: {
    type: Boolean,
    default: true,
  },
  showActiveSection: {
    type: Boolean,
    default: true,
  },
  title: {
    type: String,
    default: 'Menu',
  },
})
const emit = defineEmits(['back', 'close'])
</script>

<template>
  <div class="mobile-menu-header">
    <button v-if="showBack" class="back mobile-only" @click="emit('back')">
      <span class="">Back</span>
    </button>
    <div v-if="showActiveSection" class="active-section">{{ title }}</div>
    <button class="close mobile-only" @click="emit('close')">
      <span class="">Close</span>
    </button>
  </div>
</template>
